import { render, staticRenderFns } from "./2020under35.vue?vue&type=template&id=540643b6&scoped=true"
import script from "./2020under35.vue?vue&type=script&lang=js"
export * from "./2020under35.vue?vue&type=script&lang=js"
import style0 from "./2020under35.vue?vue&type=style&index=0&id=540643b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540643b6",
  null
  
)

export default component.exports